import { ValidationFunctionResult } from '../../../../types/validation-function-result';
import { AppSubjectEnum } from '../../../authz/enums/app-subject.enum';

/**
 * Validates payload for performing an action from the context of the specified subject.
 * @param payload - The action payload.
 * @param subject - The subject of the action.
 * @param abortEarly - Whether to abort the validation on the first error.
 * @returns The validation result.
 * @throws Error if payload is falsy.
 * @example
 * canPerformAction(payload, AppSubjectEnum.CUSTOMER);
 */
export const canPerformAction = (
	payload: any,
	subject: AppSubjectEnum.USER,
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	abortEarly: boolean = false,
): ValidationFunctionResult => {
	// Check
	if (!payload) throw new Error('Payload is required');

	// TODO: Switch on subject enum

	// Return
	return { isValid: true };
};
